import gql from 'graphql-tag';

export default gql`
  mutation DesktopCourseUploadFile($fileName: String!, $courseId: String!, $instanceId: String!) {
    desktopCourseUploadFile(fileName: $fileName, courseId: $courseId, instanceId: $instanceId) {
      courseId
      fileName
      createdAt
      updatedAt
    }
  }
`;
